import React from 'react';
import logoHG from '../../../static/img/logo_dark.png';
import '../../styles/onboarding.css';

/**
 * ChatFloatingButton
 * Bottom-right FAB, always visible on every onboarding screen.
 * On mobile: opens the chat bottom drawer.
 * On desktop: visible but chat is already in the right panel.
 * Props:
 *   onClick   — opens chat panel / drawer
 *   isOpen    — whether chat is currently open (mobile drawer state)
 */
const ChatFloatingButton = ({ onClick, isOpen = false }) => {
  return (
    <button
      type="button"
      className={`hg-chat-fab${isOpen ? ' hg-chat-fab--open' : ''}`}
      onClick={onClick}
      aria-label={isOpen ? 'Close chat' : 'Open chat assistant'}
      title="Coming soon — Phase CB"
    >
      <span className="hg-chat-fab__icon">
        {isOpen ? '✕' : <img src={logoHG} alt="Happy Guest" className="hg-chat-fab__logo" />}
      </span>
    </button>
  );
};

export default ChatFloatingButton;
